import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { BackToTop } from './BackToTop';
import { IBackToTop } from './Interface';

export const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IBackToTop = elementAttributesToProps(domNode);

  return Promise.resolve(<BackToTop {...props} />);
};

export default rehydrator;
